/* lib/PostcodeLookup/index.svelte generated by Svelte v3.20.1 */
import {
	SvelteComponentDev,
	check_outros,
	create_component,
	destroy_component,
	detach_dev,
	dispatch_dev,
	empty,
	group_outros,
	init,
	insert_dev,
	mount_component,
	safe_not_equal,
	space,
	transition_in,
	transition_out,
	validate_slots
} from "svelte/internal";

import { onDestroy, getContext, createEventDispatcher } from "svelte";
import { getTarget } from "../targets";
import Input from "./Input.svelte";
import Select from "./Select.svelte";
const file = "lib/PostcodeLookup/index.svelte";

// (53:0) {#if !target && response}
function create_if_block(ctx) {
	let current;

	const select = new Select({
			props: {
				classNames: /*classNames*/ ctx[2].select,
				onSelected: /*handleSelected*/ ctx[3],
				addresses: /*response*/ ctx[0].listAddresses()
			},
			$$inline: true
		});

	const block = {
		c: function create() {
			create_component(select.$$.fragment);
		},
		m: function mount(target, anchor) {
			mount_component(select, target, anchor);
			current = true;
		},
		p: function update(ctx, dirty) {
			const select_changes = {};
			if (dirty & /*response*/ 1) select_changes.addresses = /*response*/ ctx[0].listAddresses();
			select.$set(select_changes);
		},
		i: function intro(local) {
			if (current) return;
			transition_in(select.$$.fragment, local);
			current = true;
		},
		o: function outro(local) {
			transition_out(select.$$.fragment, local);
			current = false;
		},
		d: function destroy(detaching) {
			destroy_component(select, detaching);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block.name,
		type: "if",
		source: "(53:0) {#if !target && response}",
		ctx
	});

	return block;
}

function create_fragment(ctx) {
	let t;
	let if_block_anchor;
	let current;

	const input = new Input({
			props: {
				classNames: /*classNames*/ ctx[2].input,
				onLookup: /*handleLookup*/ ctx[4]
			},
			$$inline: true
		});

	let if_block = !/*target*/ ctx[1] && /*response*/ ctx[0] && create_if_block(ctx);

	const block = {
		c: function create() {
			create_component(input.$$.fragment);
			t = space();
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		l: function claim(nodes) {
			throw new Error("options.hydrate only works if the component was compiled with the `hydratable: true` option");
		},
		m: function mount(target, anchor) {
			mount_component(input, target, anchor);
			insert_dev(target, t, anchor);
			if (if_block) if_block.m(target, anchor);
			insert_dev(target, if_block_anchor, anchor);
			current = true;
		},
		p: function update(ctx, [dirty]) {
			if (!/*target*/ ctx[1] && /*response*/ ctx[0]) {
				if (if_block) {
					if_block.p(ctx, dirty);
					transition_in(if_block, 1);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i: function intro(local) {
			if (current) return;
			transition_in(input.$$.fragment, local);
			transition_in(if_block);
			current = true;
		},
		o: function outro(local) {
			transition_out(input.$$.fragment, local);
			transition_out(if_block);
			current = false;
		},
		d: function destroy(detaching) {
			destroy_component(input, detaching);
			if (detaching) detach_dev(t);
			if (if_block) if_block.d(detaching);
			if (detaching) detach_dev(if_block_anchor);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_fragment.name,
		type: "component",
		source: "",
		ctx
	});

	return block;
}

function instance($$self, $$props, $$invalidate) {
	let { getClient } = $$props;
	const { selectTarget, classNames = {} } = getContext("style") || {};
	const dispatch = createEventDispatcher();
	let address = null;
	let response = null;
	let selectComponent;

	const unmountSelectComponent = () => {
		if (selectComponent) {
			selectComponent.$destroy();
		}
	};

	const handleSelected = value => {
		address = response.formatAddress(value);
		dispatch("address", address);
	};

	const handleLookup = async value => {
		$$invalidate(0, response = await getClient().getPostcode(value));

		if (target) {
			unmountSelectComponent();

			selectComponent = new Select({
					target,
					props: {
						onSelected: handleSelected,
						addresses: response.listAddresses()
					}
				});
		}
	};

	onDestroy(() => unmountSelectComponent());
	const writable_props = ["getClient"];

	Object.keys($$props).forEach(key => {
		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== "$$") console.warn(`<Index> was created with unknown prop '${key}'`);
	});

	let { $$slots = {}, $$scope } = $$props;
	validate_slots("Index", $$slots, []);

	$$self.$set = $$props => {
		if ("getClient" in $$props) $$invalidate(5, getClient = $$props.getClient);
	};

	$$self.$capture_state = () => ({
		onDestroy,
		getContext,
		createEventDispatcher,
		getTarget,
		Input,
		Select,
		getClient,
		selectTarget,
		classNames,
		dispatch,
		address,
		response,
		selectComponent,
		unmountSelectComponent,
		handleSelected,
		handleLookup,
		target
	});

	$$self.$inject_state = $$props => {
		if ("getClient" in $$props) $$invalidate(5, getClient = $$props.getClient);
		if ("address" in $$props) address = $$props.address;
		if ("response" in $$props) $$invalidate(0, response = $$props.response);
		if ("selectComponent" in $$props) selectComponent = $$props.selectComponent;
		if ("target" in $$props) $$invalidate(1, target = $$props.target);
	};

	let target;

	if ($$props && "$$inject" in $$props) {
		$$self.$inject_state($$props.$$inject);
	}

	$: $$invalidate(1, target = getTarget(selectTarget));
	return [response, target, classNames, handleSelected, handleLookup, getClient];
}

class Index extends SvelteComponentDev {
	constructor(options) {
		super(options);
		init(this, options, instance, create_fragment, safe_not_equal, { getClient: 5 });

		dispatch_dev("SvelteRegisterComponent", {
			component: this,
			tagName: "Index",
			options,
			id: create_fragment.name
		});

		const { ctx } = this.$$;
		const props = options.props || {};

		if (/*getClient*/ ctx[5] === undefined && !("getClient" in props)) {
			console.warn("<Index> was created without expected prop 'getClient'");
		}
	}

	get getClient() {
		throw new Error("<Index>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set getClient(value) {
		throw new Error("<Index>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}
}

export default Index;